import {
  QuestionnaireResponse,
  StorePreferenceCreateRequest,
  StoreQuestionnaireStatusRequest,
  StoreQuestionnaireStatusType,
} from '@tiendanube/common';
import { cirrusApi } from 'App/rtk';
import { preOnboardingTags } from './tags';
import { PreOnboardingEndpoints } from './types';
import {
  CREATE_QUESTIONNAIRE_STORE_PREFERENCES,
  QUESTIONNAIRE_OPTIONS,
  QUESTIONNAIRE_STORE_STATUS,
} from './urls';

export const preOnboardingApi = cirrusApi
  .enhanceEndpoints({
    addTagTypes: [preOnboardingTags.questionnaireStatus],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      [PreOnboardingEndpoints.getQuestionnaireStatus]: builder.query<
        StoreQuestionnaireStatusType,
        void
      >({
        query: () => ({
          method: 'GET',
          url: QUESTIONNAIRE_STORE_STATUS,
        }),
        providesTags: [preOnboardingTags.questionnaireStatus],
      }),
      [PreOnboardingEndpoints.getQuestionnaireOptions]: builder.query<
        QuestionnaireResponse,
        void
      >({
        query: () => ({
          method: 'GET',
          url: QUESTIONNAIRE_OPTIONS,
        }),
      }),
      [PreOnboardingEndpoints.updateStoreQuestionnaireStatus]: builder.mutation<
        void,
        StoreQuestionnaireStatusRequest
      >({
        query: (payload) => ({
          method: 'POST',
          url: QUESTIONNAIRE_STORE_STATUS,
          data: payload,
        }),
      }),
      [PreOnboardingEndpoints.createQuestionnaireStorePreferences]:
        builder.mutation<void, StorePreferenceCreateRequest>({
          query: (payload) => ({
            method: 'POST',
            url: CREATE_QUESTIONNAIRE_STORE_PREFERENCES,
            data: payload,
          }),
          invalidatesTags: (_, error) =>
            error ? [] : [preOnboardingTags.questionnaireStatus],
        }),
    }),
  });

export const {
  useGetQuestionnaireStatusQuery,
  useGetQuestionnaireOptionsQuery,
  useUpdateQuestionnaireStatusMutation,
  useCreateQuestionnaireStorePreferencesMutation,
  useLazyGetQuestionnaireStatusQuery,
} = preOnboardingApi;
